module.exports = __webpack_public_path__ + "img/green-energy.7b2b980.webp";